import { Mail, MessageSquareText, Sparkles, Trash2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { MicButton } from "@/components/MicButton";
import { VarChips } from "@/components/steps/TemplateEditor";

const segments = (text) => Math.max(1, Math.ceil((text.length + 11) / 160));

const SmsAssist = ({ text, onText, testid, variables }) => {
  const [ask, setAsk] = useState("");
  const [busy, setBusy] = useState(false);
  const draft = async () => {
    setBusy(true);
    try { onText((await api.post("/sms/ai-draft", { instruction: `${ask} (SMS automatique : n'utilise QUE ces variables entre accolades si utile, aucune autre : ${(variables || []).map((v) => `{${v.key}}`).join(", ")})`, current: text })).data.text); } catch (e) { toast.error(e?.response?.data?.detail || "Rédaction impossible."); } finally { setBusy(false); }
  };
  return (
    <div className="sms-ai" data-testid={`${testid}-ai`}>
      <span className="sms-ai-title"><Sparkles size={14} /> Rédiger avec l'IA</span>
      <div className="sms-ai-row">
        <input value={ask} placeholder="Ex. : remercier pour l'échange et proposer un rendez-vous technique" onChange={(e) => setAsk(e.target.value)} data-testid={`${testid}-ai-instruction`} />
        <MicButton onText={(t) => setAsk((a) => `${a} ${t}`.trim())} testid={`${testid}-ai-mic`} label="Dicter" />
        <button type="button" className="secondary-button" disabled={ask.trim().length < 3 || busy} onClick={draft} data-testid={`${testid}-ai-generate`}>{busy ? "Rédaction…" : "Rédiger"}</button>
      </div>
    </div>
  );
};

export const ActionEditor = ({ action, index, templates, variables, onChange, onRemove, onNewTemplate }) => {
  const tid = index === 0 ? "rule" : `rule-action-${index}`;
  const set = (k, v) => onChange({ ...action, [k]: v });
  return (
    <div className="sr-action" data-testid={`${tid}-block`}>
      <div className="sr-action-head">
        <strong>Envoi n° {index + 1}</strong>
        <div className="pj-seg sr-channel">
          <button type="button" className={action.channel === "email" ? "is-on" : ""} onClick={() => set("channel", "email")} data-testid={`${tid}-channel-email`}><Mail size={15} />E-mail</button>
          <button type="button" className={action.channel === "sms" ? "is-on" : ""} onClick={() => set("channel", "sms")} data-testid={`${tid}-channel-sms`}><MessageSquareText size={15} />SMS</button>
        </div>
        {onRemove && <button type="button" className="pl-icon-btn" onClick={onRemove} aria-label="Retirer cet envoi" data-testid={`${tid}-remove`}><Trash2 size={14} /></button>}
      </div>
      <div className="sr-delay">
        <label>Délai avant envoi — jours<input type="number" min="0" max="365" value={action.delay_days} onChange={(e) => set("delay_days", e.target.value)} data-testid={`${tid}-delay-days`} /></label>
        <label>et heures<input type="number" min="0" max="23" value={action.delay_hours} onChange={(e) => set("delay_hours", e.target.value)} data-testid={`${tid}-delay-hours`} /></label>
      </div>
      {action.channel === "email" ? (
        <label>Modèle d'e-mail
          <div className="sr-inline">
            <select value={action.template_id || ""} onChange={(e) => set("template_id", e.target.value)} data-testid={`${tid}-template`}><option value="">Choisir un modèle</option>{templates.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}</select>
            <button type="button" className="secondary-button" onClick={onNewTemplate} data-testid={`${tid}-new-template`}>Nouveau modèle</button>
          </div>
        </label>
      ) : (
        <>
          <SmsAssist text={action.sms_text} onText={(t) => set("sms_text", t)} testid={tid} variables={variables} />
          <label>Texte du SMS
            <textarea rows={4} maxLength={640} value={action.sms_text} onChange={(e) => set("sms_text", e.target.value)} placeholder="Bonjour {contact}, …" data-testid={`${tid}-sms-text`} />
            <div className="sr-inline">
              <MicButton onText={(t) => set("sms_text", `${action.sms_text} ${t}`.trim())} testid={`${tid}-sms-mic`} label="Dicter le SMS" />
              <small className="pj-sub" data-testid={`${tid}-sms-count`}>{action.sms_text.length} caractères · {segments(action.sms_text)} SMS · mention « STOP » ajoutée · envoyé lun–sam 8h–20h</small>
            </div>
            <VarChips variables={variables} onPick={(v) => set("sms_text", `${action.sms_text}${v}`)} />
          </label>
        </>
      )}
    </div>
  );
};
